/**
 * Help Centre permission key.
 *
 * One key, held by editors only — READING the manual needs no key at all, because every guide is
 * already filtered server-side by the module gates the reader holds. `help_centre_manage` gates the
 * `admin/*` editor routes in api.core (`[HasAction]`) and the `/admin/help/manage` pages here.
 *
 * Seeded and granted to Administrator / Super Admin by api.core's `PermissionBootstrapHostedService`
 * on boot; editors must re-login afterwards, because `action` claims are stamped at mint time.
 */
export const ACTIONS_HELP_CENTRE = {
	HELP_CENTRE_MANAGE: 'help_centre_manage',
} as const;
